import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Sidebar.css';

const firstCharacter = (text) => {
  const trimmed = String(text || '').trim();
  if (!trimmed) return '';
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const first = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(trimmed)[Symbol.iterator]().next();
    return first.done ? '' : first.value.segment;
  }
  return Array.from(trimmed)[0];
};

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useAuth();
  const displayName = user?.name || user?.username || 'User';
  const avatarInitial = (firstCharacter(displayName) || '?').toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/items', label: 'Items', icon: '📦' },
    { path: '/wheels', label: 'Wheels', icon: '🛒' },
    { path: '/pallets', label: 'Pallets', icon: '📦' },
    { path: '/shipments', label: 'Shipments', icon: '🚚' },
    { path: '/inventory', label: 'Inventory', icon: '📋' },
  ];

  // Feature flag: QB integration hidden until paid
  const QB_FEATURE_ENABLED = false;

  if (isAdmin()) {
    navItems.push({ path: '/reports', label: 'Analytics', icon: '📈' });
    navItems.push({ path: '/customers', label: 'Customers', icon: '👥' });
    if (QB_FEATURE_ENABLED) {
      navItems.push({ path: '/quickbooks', label: 'QuickBooks', icon: '📗' });
    }
    navItems.push({ path: '/settings', label: 'Settings', icon: '⚙️' });
  }

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src="/logo.png" alt="Montreal Kosher" className="sidebar-logo" />
          <h3 className="sidebar-title">MK Pallets</h3>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{avatarInitial}</div>
            <div className="user-details">
              <div className="user-name">{displayName}</div>
              <div className="user-role">{user?.role || 'staff'}</div>
            </div>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            <span className="logout-icon">🚪</span>
            <span className="logout-label">Logout</span>
          </button>
        </div>
      </aside>

      {isOpen && <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />}
    </>
  );
};

export default Sidebar;
